<template>
  <div id="app">
      <div v-if="loginInProgress">
        <b-loading :is-full-page="true" active.sync="true" :can-cancel="false"></b-loading>
      </div>

      <div v-if="authorized" style="padding-bottom: 50px;">

          <nav class="navbar is-link is-hidden-print" role="navigation" aria-label="main navigation" v-if="navbarVisible" style="height: 70px; margin-bottom: 35px;">
              <div class="container">
              <div class="navbar-brand">
                  <router-link class="navbar-item" to="/tournaments">
                      <b-icon pack="fas" icon="paper-plane" size="is-small" /> &nbsp; &nbsp;

                      <strong style="text-transform: uppercase;">Tournament planner</strong>
                  </router-link>
              </div>

              <div class="navbar-menu">
                  <div class="navbar-start">

                  </div>

                  <div class="navbar-end">
                      <div class="navbar-item">
                          <div class="buttons">
                              <router-link class="button is-link" to="/tournaments">
                                  <strong>Tournaments</strong>
                              </router-link>

                              <a class="button is-link" @click="triggerLogout">
                                  <strong>Log out</strong>
                              </a>
                          </div>
                      </div>
                  </div>
              </div>
              </div>
          </nav>


          <div class="container">
              <router-view></router-view>
          </div>
      </div>
    </div>
</template>


<script>
  export default {
    computed: {
      loginInProgress: function() { return this.$store.state.loginInProgress; },
      authorized:  function() { return (this.$store.state.token ? true : (this.$route.path.indexOf('/auth/') >= 0)); },

      navbarVisible: function() { return (this.$store.state.token && this.$route.path.indexOf('/auth/') < 0); },
      needsAuthorization:  function() { return (!this.loginInProgress && !this.authorized); }
    },
    methods: {
      alert() {
        this.$dialog.alert('Everything looks bad!');

      },

      triggerLogout() {
          this.$dialog.confirm({
              message: 'Are you sure you want to logout?',
              type: 'is-danger',
              onConfirm: () => { this.$store.dispatch('logout'); }
          });
      }
    },

    watch: {
      needsAuthorization: function() {
          if (this.needsAuthorization) {
              this.$router.replace('/auth/login');
          }
      }
    },

    created: function(){
      this.$store.dispatch('autoLogin');
    }
  }
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }
  #nav {
    padding: 30px;
  }

  #nav a {
    font-weight: bold;
    color: #2c3e50;
  }

  #nav a.router-link-exact-active {
    color: #42b983;
  }


  div.card-background {
      background-color: white;
      -webkit-box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
      box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
      color: #4a4a4a;
      max-width: 100%;
      position: relative;
      padding: 1.5rem;
  }



  @media print {
      .is-hidden-print {
          display: none;
          display: none !important;
      }

      .is-full-printer {
          -webkit-box-flex: 0;
          -ms-flex: none;
          flex: none;
          width: 100% !important;
      }
  }
</style>
